const stripApiSuffix = (base) => (base || '').replace(/\/api\/?$/, '');

const getAssetBase = () => {
  const apiBase = process.env.REACT_APP_API_BASE_URL || '';
  const assetBase = process.env.REACT_APP_ASSET_BASE_URL || apiBase;
  const stripped = stripApiSuffix(assetBase);
  if (stripped) return stripped;

  if (typeof window === 'undefined') return '';

  if (process.env.NODE_ENV !== 'production') return window.location.origin;

  return window.location.origin;
};

const toAbsoluteBase = (base) => {
  if (!base) return '';
  if (/^https?:\/\//i.test(base)) return base;
  if (typeof window === 'undefined') return base;
  return new URL(base, window.location.origin).toString();
};

const buildVariantUrl = (path, options = {}) => {
  const width = Number(options.width || options.w || 0);
  if (!width || !path.startsWith('/uploads/')) return '';

  const params = new URLSearchParams({
    src: path,
    w: String(Math.round(width)),
  });
  const height = Number(options.height || options.h || 0);
  if (height) params.set('h', String(Math.round(height)));
  if (options.fit) params.set('fit', options.fit);
  if (options.quality || options.q) params.set('q', String(options.quality || options.q));
  if (options.format) params.set('format', options.format);

  const base = toAbsoluteBase(getAssetBase()).replace(/\/$/, '');
  return `${base}/api/media/variant?${params.toString()}`;
};

export const resolveAssetUrl = (url, options = {}) => {
  if (!url) return '';
  const clean = String(url).trim().replace(/\\/g, '/');
  if (!clean) return '';
  if (/^https?:\/\//i.test(clean)) {
    try {
      const parsed = new URL(clean);
      if (
        parsed.pathname.startsWith('/uploads/') &&
        (parsed.hostname === 'api.homevilas.com' ||
          parsed.hostname === 'localhost' ||
          parsed.hostname === '127.0.0.1')
      ) {
        const variantUrl = buildVariantUrl(parsed.pathname, options);
        if (variantUrl) return variantUrl;
      }
    } catch (_) {
      // keep original URL
    }
    return clean;
  }
  const normalizedPath = clean.startsWith('/') ? clean : `/${clean}`;
  const variantUrl = buildVariantUrl(normalizedPath, options);
  if (variantUrl) return variantUrl;
  const base = toAbsoluteBase(getAssetBase());
  if (!base) return clean.startsWith('/') ? clean : `/${clean}`;
  try {
    return new URL(clean, base).toString();
  } catch (_) {
    const trimmedBase = base.replace(/\/$/, '');
    if (clean.startsWith('/')) return `${trimmedBase}${clean}`;
    return `${trimmedBase}/${clean}`;
  }
};


